<template>
  <PriceRangeWithTextFieldField :choices="choices" v-on="$listeners" />
</template>

<script>
import PriceRangeWithTextFieldField from 'chimera/all/components/form/fields/priceRange/PriceRangeWithTextFieldField'
import { Selectable } from 'chimera/all/components/models/Selectable'

export default {
  name: 'PriceRangeRadioFormPart',

  components: {
    PriceRangeWithTextFieldField,
  },

  /**
   * The comp drops the two lowest brackets and "Weet ik niet". Values are
   * copied verbatim from the control part — partners receive these strings,
   * so only the option set changes, never the wording.
   *
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable(
          '€200.000 - €300.000',
          '€200.000 - €300.000',
          '€200.000 - €300.000',
        ),
        new Selectable(
          '€300.000 - €400.000',
          '€300.000 - €400.000',
          '€300.000 - €400.000',
        ),
        new Selectable(
          '€400.000 - €500.000',
          '€400.000 - €500.000',
          '€400.000 - €500.000',
        ),
        new Selectable(
          '€500.000 - €750.000',
          '€500.000 - €750.000',
          '€500.000 - €750.000',
        ),
        new Selectable(
          'Meer dan €750.000',
          'Meer dan €750.000',
          'Meer dan €750.000',
        ),
      ],
    }
  },
}
</script>
